export default __webpack_public_path__ + "static/media/logo.334af94e.webp";